import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "search",
})
export class SearchPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    }
    return value.filter(
      (val) =>
        val.ENG_NAME &&
        (val.ENG_NAME.toLocaleLowerCase().includes(args.toLocaleLowerCase()) ||
          val.ARB_NAME.toLocaleLowerCase().includes(args.toLocaleLowerCase()) ||
          val.SYMBOL_CODE.toLocaleLowerCase().includes(
            args.toLocaleLowerCase()
          ) ||
          val.Reuters.toLocaleLowerCase().includes(args.toLocaleLowerCase()))
    );
  }
}
